import styled from "styled-components";

export const Button = styled.button`
  border-radius: 3px;
  padding: 0.5em 2em;
  margin: 1em 0;
  background: transparent;
  color: #1565c0;
  cursor: pointer;
  border: 2px solid #1565c0;
`;



// WEBPACK FOOTER //
// ./src/components/Button/styles.ts